import React, { useEffect, useState } from 'react';
import './thankyou.css';
import { useDispatch, useSelector } from 'react-redux';
import { selectAdminToken } from '../../admin/sessionSlice';
import { setBackButtonUrl } from '../uiSlice';

const S3 = process.env.REACT_APP_S3_PATH || '';
const SPOT_MSG_KEY = 'spotThankYouMsg';

function ThankYou() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const adminToken = useSelector(selectAdminToken);
  const { data: themeData } = useSelector((state) => state.theme);
  const [scoreLine, setScoreLine] = useState('');

  useEffect(() => {
    dispatch(setBackButtonUrl(user?.backButtonRedirect));
  }, [dispatch, user]);

  useEffect(() => {
    const stored = sessionStorage.getItem(SPOT_MSG_KEY);
    if (stored) {
      setScoreLine(stored);
    }
  }, []);

  const gifSrc = themeData?.thank_you_page
    ? S3 + themeData.thank_you_page
    : '/thankyou.gif';

  const heading =
    themeData?.custom_text_thank_you_page || 'Thank you for playing';
  const textColor =
    themeData?.text_color || themeData?.colors?.text_color || 'inherit';

  return (
    <div className="thankyou-main-container" style={{ textAlign: 'center' }}>
      <div className="thankyou-main-container1" style={{ textAlign: 'center' }}>
        <img src={gifSrc} className="login-logo" alt="" />
      </div>
      <div>
        <h2 className="thankyou-heading" style={{ color: textColor }}>
          {heading}
        </h2>
        {scoreLine && (
          <p className="score" style={{ margin: '10px 0', color: textColor }}>
            {scoreLine}
          </p>
        )}
      </div>
    </div>
  );
}

export default ThankYou;
